import {
  DST_SRT_PROJECT_PROCESSING_STATUSES,
  DST_SRT_UPLOADING_STATUSES,
  DUBBING_ERROR_STATUSES,
  NOT_UPDATING_STATUSES,
  PROJECT_PROCESSING_STATUSES,
  PROJECT_TASK_TYPE,
  SRC_AND_SRT_UPLOADING_STATUSES,
  SRC_SRT_PROJECT_PROCESSING_STATUSES,
  SRC_SRT_UPLOADING_STATUSES,
} from '@/entities/project';

import { Project } from '@/shared/types/Project';
import { Status } from '@/shared/types/Status';

type GetProjectProcessingInfo = {
  isAutogeneratingProject: boolean;
  isProjectAlreadyWasProcessed: boolean;
  project: Project | undefined;
};

export const getProjectProcessingInfo = ({
  isAutogeneratingProject,
  isProjectAlreadyWasProcessed,
  project,
}: GetProjectProcessingInfo) => {
  if (!project) {
    return null;
  }

  const { dst_srt_uploaded, src_srt_uploaded } = project;

  if (src_srt_uploaded && dst_srt_uploaded && isProjectAlreadyWasProcessed) {
    return {
      finalStatuses: NOT_UPDATING_STATUSES,
      statuses: SRC_AND_SRT_UPLOADING_STATUSES,
      taskType: PROJECT_TASK_TYPE.SrcAndDstSrtUploading,
    };
  }

  if (src_srt_uploaded && isProjectAlreadyWasProcessed) {
    return {
      finalStatuses: NOT_UPDATING_STATUSES,
      statuses: SRC_SRT_UPLOADING_STATUSES,
      taskType: PROJECT_TASK_TYPE.SrcSrtUploading,
    };
  }

  if (dst_srt_uploaded && isProjectAlreadyWasProcessed) {
    return {
      finalStatuses: [Status.voiceSuggestDone, Status.voiceSuggestFailed, ...NOT_UPDATING_STATUSES],
      statuses: DST_SRT_UPLOADING_STATUSES,
      taskType: PROJECT_TASK_TYPE.DstSrtUploading,
    };
  }

  if (src_srt_uploaded && !dst_srt_uploaded) {
    return {
      finalStatuses: isAutogeneratingProject
        ? [...DUBBING_ERROR_STATUSES, Status.mergingDone]
        : [Status.translationDone],
      statuses: SRC_SRT_PROJECT_PROCESSING_STATUSES,
      taskType: isAutogeneratingProject
        ? PROJECT_TASK_TYPE.VideoWithSrcSrtUploadingWithGenerating
        : PROJECT_TASK_TYPE.VideoWithSrcSrtUploading,
    };
  }
  if (dst_srt_uploaded) {
    return {
      finalStatuses: isAutogeneratingProject
        ? [...DUBBING_ERROR_STATUSES, Status.mergingDone]
        : [Status.voiceSuggestDone, Status.voiceSuggestFailed],
      statuses: DST_SRT_PROJECT_PROCESSING_STATUSES,
      taskType: isAutogeneratingProject
        ? PROJECT_TASK_TYPE.VideoWithDstSrtUploadingWithGenerating
        : PROJECT_TASK_TYPE.VideoWithDstSrtUploading,
    };
  }
  return {
    finalStatuses: isAutogeneratingProject ? [...DUBBING_ERROR_STATUSES, Status.mergingDone] : [Status.translationDone],
    statuses: PROJECT_PROCESSING_STATUSES,
    taskType: isAutogeneratingProject
      ? PROJECT_TASK_TYPE.VideoUploadingWithGenerating
      : PROJECT_TASK_TYPE.VideoUploading,
  };
};
